import TableCell from '@mui/material/TableCell';
import { withStyles } from '@mui/styles';

export const CustomTableCellText = withStyles((theme) => ({
    root: {
        width: '25%',
    },
}))(TableCell);